import React from 'react';
import * as Cookies from 'js-cookie';

export const setSessionCookie = (session, config={}, callback) => {
  var sessionCookieName = `bps-session-${config.userId}`;
  // console.log('setSessionCookie input:', session, config, sessionCookieName);
  Cookies.remove(sessionCookieName);
  var expireDays = (config.web_session_timeout || 5000) / (24 * 60);
  if (session) {
    Cookies.set(sessionCookieName, session, { expires:expireDays });
  }
  setTimeout(callback, 500);
};

export const getSessionCookie = (config={}) => {
  var sessionCookieName = `bps-session-${config.userId}`;
  // console.log('getSessionCookie input:', config, sessionCookieName);
  let sessionCookie = null;
  if (sessionCookieName !== 'bps-session-undefined') {
    sessionCookie = Cookies.get(sessionCookieName);
    // console.log('getSessionCookie result:', sessionCookie);
  }
  if (sessionCookie) {
    return JSON.parse(sessionCookie);
  } else {
    return {};
  } 
};

export const SessionContext = React.createContext(getSessionCookie({}));
